import SingleCalendarButton from "@components/ui-kit/SingleCalendarButton";
import styles from "./styles.module.scss";

interface FormDateWrapperProps {
  label: string;
  onChange: (value: Date) => void;
  optional?: boolean;
  disabled?: boolean;
}

const FormDateWrapper: React.FC<FormDateWrapperProps> = ({
  label,
  onChange,
  optional = false,
}) => {
  return (
    <div className={styles.wrapperDatePicker}>
      <label className={styles.label}>
        {label}{" "}
        {optional && <span className={styles.optional}>(optional)</span>}
      </label>
      <SingleCalendarButton onChange={onChange} />
    </div>
  );
};

export default FormDateWrapper;
